import { useEffect, useState } from "react";
import { ArrowRight, Menu, X } from "lucide-react";
import { scrollToId } from "./shared";

const LINKS = [
    ["How it works", "#how-it-works", "nav-link-how-it-works"],
    ["What you can do", "#what-you-can-do", "nav-link-what-you-can-do"],
    ["Expert help", "#team", "nav-link-expert-help"],
    ["Pricing", "#pricing", "nav-link-pricing"],
];

export const Nav = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (href) => {
        setOpen(false);
        scrollToId(href);
    };

    return (
        <header className="fixed inset-x-0 top-0 z-50">
            <div
                className={`overflow-hidden bg-ink text-white transition-all duration-300 ${scrolled ? "max-h-0" : "max-h-12"}`}
                data-testid="announcement-bar"
            >
                <div className="mx-auto flex max-w-6xl items-center justify-center gap-2 px-5 py-2.5 text-xs font-bold sm:text-sm">
                    Purple Business is opening soon.
                    <button
                        data-testid="announcement-cta"
                        onClick={() => go("#become")}
                        className="inline-flex items-center gap-1 text-white underline decoration-white/40 underline-offset-4 transition-colors hover:decoration-white"
                    >
                        Join the waitlist <ArrowRight className="h-3.5 w-3.5" />
                    </button>
                </div>
            </div>

            <div className="mx-auto mt-3 flex max-w-6xl items-center justify-between gap-3 px-4">
                <div className="flex items-center rounded-full border border-neutral-200/70 bg-white/85 py-2 pl-4 pr-2 shadow-sm backdrop-blur-xl">
                    <button
                        data-testid="nav-logo"
                        onClick={() => (window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }))}
                        aria-label="Purple Business — back to top"
                    >
                        <img src="/assets/logo-dark.png" alt="Purple Business" className="h-8 w-auto rounded-lg" />
                    </button>
                    <div className="ml-3 hidden items-center gap-0.5 lg:flex">
                        {LINKS.map(([label, href, id]) => (
                            <button
                                key={href}
                                data-testid={id}
                                onClick={() => go(href)}
                                className="rounded-full px-4 py-2 text-sm font-bold text-neutral-600 transition-colors hover:bg-paper hover:text-ink"
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="flex items-center gap-2">
                    <button
                        data-testid="nav-cta-become"
                        onClick={() => go("#become")}
                        className="hidden rounded-full bg-ink px-5 py-2.5 text-sm font-bold text-white shadow-sm transition-colors duration-300 hover:bg-neutral-700 sm:inline-flex"
                    >
                        Become a Purple Business
                    </button>
                    <button
                        data-testid="nav-menu-toggle"
                        onClick={() => setOpen(!open)}
                        className="flex h-10 w-10 items-center justify-center rounded-full border border-neutral-200/70 bg-white/85 shadow-sm backdrop-blur-xl lg:hidden"
                        aria-label="Toggle menu"
                    >
                        {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="mx-4 mt-2 rounded-3xl border border-neutral-200 bg-white p-5 shadow-xl lg:hidden" data-testid="nav-mobile-menu">
                    {LINKS.map(([label, href, id]) => (
                        <button
                            key={href}
                            data-testid={`${id}-mobile`}
                            onClick={() => go(href)}
                            className="block w-full py-3 text-left font-display text-xl font-bold text-ink"
                        >
                            {label}
                        </button>
                    ))}
                    <button
                        data-testid="nav-cta-become-mobile"
                        onClick={() => go("#become")}
                        className="mt-3 w-full rounded-full bg-ink py-3.5 text-base font-bold text-white"
                    >
                        Become a Purple Business
                    </button>
                </div>
            )}
        </header>
    );
};
